import { feeMoneyCents, feeMoneyText, type FeeAdjustmentRecord } from "../../fee-adjustment";
import { calculateCustomerQuoteMarginRate } from "./draftService";

/** 以实际成本差额叠加已完成销售申请，统一推导当前支付和利润；缺失金额保留未知。 */
export function buildFeeAdjustmentQuoteSummary(
  baseline: { internalCostTotalAmount: string; receivableTotalAmount: string; agentCollectionTotalAmount: string },
  records: readonly FeeAdjustmentRecord[],
) {
  const frozenCost = feeMoneyCents(baseline.internalCostTotalAmount);
  const frozenReceivable = feeMoneyCents(baseline.receivableTotalAmount);
  const agentCollection = feeMoneyCents(baseline.agentCollectionTotalAmount);
  if (frozenCost === null || frozenReceivable === null || agentCollection === null) return null;

  let costDelta = 0n;
  let receivableDelta = 0n;
  for (const record of records) {
    if (record.status !== "processed") continue;
    const cost = feeMoneyCents(record.total_cost_delta_amount);
    const receivable = feeMoneyCents(record.total_receivable_delta_amount);
    if (cost === null || receivable === null) return null;
    costDelta += cost;
    receivableDelta += receivable;
  }
  const currentCost = frozenCost + costDelta;
  const currentReceivable = frozenReceivable + receivableDelta;
  const currentPayment = currentReceivable + agentCollection;
  const currentProfit = currentPayment - currentCost;
  const frozenProfit = frozenReceivable + agentCollection - frozenCost;
  const profitDelta = receivableDelta - costDelta;
  if ([currentCost, currentReceivable, currentPayment, currentProfit, frozenProfit, costDelta, receivableDelta, profitDelta]
    .some((amount) => feeMoneyCents(feeMoneyText(amount)) === null)) return null;

  return {
    frozenReceivableAmount: feeMoneyText(frozenReceivable),
    frozenCostAmount: feeMoneyText(frozenCost),
    frozenProfitAmount: feeMoneyText(frozenProfit),
    costDeltaAmount: feeMoneyText(costDelta),
    receivableDeltaAmount: feeMoneyText(receivableDelta),
    profitDeltaAmount: feeMoneyText(profitDelta),
    internalCostTotalAmount: feeMoneyText(currentCost),
    receivableTotalAmount: feeMoneyText(currentReceivable),
    customerPaymentTotalAmount: feeMoneyText(currentPayment),
    grossProfitAmount: feeMoneyText(currentProfit),
    marginRate: calculateCustomerQuoteMarginRate(currentProfit, currentCost),
  };
}
